import { StoreService } from "../../../_services";
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";

export function createStoreNrValidator(storeService: StoreService, exclude_nrs_from_check?: string[]): AsyncValidatorFn {
  return async (control:AbstractControl) : Promise<ValidationErrors | null> => {
    return new Promise<ValidationErrors | null>(resolve => {
      if (exclude_nrs_from_check && exclude_nrs_from_check.includes(control.value)) {
        resolve(null)
      } else {
        storeService.getStoresWithStoreNr(control.value).subscribe(
          data => {
            if (!data.length) {
              resolve(null)
            } else {
              resolve({alreadyUsed: {id: data[0].id}})
            }
          },
          error => {
            resolve({backEndError:true})
          }
        )
      }
    })
  }
}